export default __webpack_public_path__ + "static/media/Audio-Number-13.4d446138.mp3";